// @ts-nocheck


import React, { Component } from 'react';
import { connect } from 'react-redux';









const withUserAccess = (
WrappedComponent) =>
{
  class WithUserAccess extends Component {
    render() {
      return (
        <WrappedComponent
          {...this.props}
          userAccess={this.props.userAccess}
          employeeBranchOrgUnitId={this.props.employeeBranchOrgUnitId} />);


    }
  }

  return connect((state) => ({
    userAccess: state.auth.profile.access,
    userProfile: state.auth.profile,
    employeeBranchOrgUnitId: state.auth.profile.employeeBranchOrgUnitId
  }))(WithUserAccess);
};

export default withUserAccess;
